import { Fragment, useEffect, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import PaginadorComponent from "../../components/PaginadorComponent";
import { Icon } from "@iconify/react/dist/iconify.js";
import LoaderComponent from "../../components/LoaderComponent";
import stylebtn from '../../styles/btn.module.scss';
import { Link } from "react-router-dom";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import AlertComponent from "../../components/AlertComponent";
import InputComponent from "../../components/InputComponent";
import ParrafoComponent from "../../components/ParrafoComponent";
import { deleteUserApi, editarUserApi, getUsers, postUser } from "../../api/Users";
import { useAuth } from "../../context/AuthContext";

const ConfigurarUsersPege = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [showEliminar, setShowEliminar] = useState(false);
    const [currentUser, setCurrentUser] = useState([]);
    const [alert, setAlert] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [showEdit, setShowEdit] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const { isSuper } = useAuth();
    const [formDataUser, setFormDataUser] = useState({
        nombre: '',
        username: '',
        password: '',
        rol: '',
        pin: ''
    });

    const [addUser, setAddUser] = useState(false);
    const itemsPerPage = 7;
    const pageCount = Math.ceil(data.length / itemsPerPage);
    const currentPageDataUser = data.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    //metodos para el popup de eliminar un cliente 
    const handleCloseEliminar = () => setShowEliminar(false);
    const handleShowEliminar = async (user) => {
        setShowEliminar(true);
        setCurrentUser(user);
    }

    const handleClose = () => {
        setShowEdit(false);
        setAddUser(false);
    };

    //metodo para mostrar el popup de editar
    const handleShowAdd = () => {
        setShowEdit(true);
        setAddUser(true);
        setFormDataUser({
            nombre: "",
            username: "",
            password: "",
            rol: "",
            pin: ''
        });
    };

    //metodo para mostrar el popup de editar
    const handleShowEditar = (item) => {
        setShowEdit(true);
        setCurrentUser(item);

        setFormDataUser({
            nombre: item?.nombre,
            username: item?.username,
            password: item?.password,
            rol: item?.rol,
             pin: item?.pin,
        });
    };

    // Manejar el cambio en el input
    const handleInputChangeUser = (event) => {
        const { name, value } = event.target;
        setFormDataUser({
            ...formDataUser,
            [name]: value,
        });
    };

    const mostrarUser = async (filters = {}) => {
        setLoading(true);
        try {
            const res = await getUsers(filters);
            setData(res?.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        mostrarUser();
    }, [])


    const eliminarUser = async () => {
        try {
            const res = await deleteUserApi(currentUser?.id);
            if (res.success) {
                handleCloseEliminar();
                mostrarUser();
                setAlert(true);
                setMensaje(res.msg);
            } else {
                setMensaje(res.msg);
            }
        } catch (error) {
            console.log(error);
        }

        setTimeout(() => {
            setAlert(false)
        }, [5000]);
    }

    const editarUser = async (e) => {
        e.preventDefault();
        try {
            const resP = await editarUserApi(currentUser.id, formDataUser);


            if (resP.success) {
                setAlert(true);
                mostrarUser();
                handleClose();
            }
            setMensaje(resP.msg);
        } catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            setAlert(false);
            setMensaje('');
        }, 3000);
    }


    const buscarcliente = (e) => {
        e.preventDefault();
        const filters = {
            searchQuery: searchQuery,
        };

        mostrarUser(filters);
    }



    const addUsuario = async (e) => {
        e.preventDefault();
        try {

            if (formDataUser.username === "" || formDataUser.rol === "" || formDataUser.password === "") {
                setMensaje("Todo los campos * son obligatorios")
            } else {
                const resU = await postUser(formDataUser);
                if (resU.success) {
                    setAlert(true);
                    setMensaje(resU.msg);
                    mostrarUser();
                    handleClose();
                } else {
                    setMensaje(resU.msg);
                }
            }


        } catch (error) {
            console.log(error);
        }
        setTimeout(() => {
            setAlert(false);
            setMensaje('');
        }, 3000);
    }
    return (
        <Fragment>

            <div className='d-flex justify-content-center'>
                <AlertComponent styleGroup="bg-soccess color-white" mensaje={mensaje} activaalert={alert} />
            </div>
            <HeaderComponent>
                <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">USUARIOS</TitleH2Component>
                <button onClick={handleShowAdd} type="button" className={`${stylebtn.btn} ${stylebtn.primary} `}>
                    AGREGAR
                </button>
            </HeaderComponent>
            {loading ? (
                <LoaderComponent styleGroup="mt-5" />
            ) : (
                <div className="conatiner-global pt-3 mb-5">

                    <section>
                        <div className="container">
                            <form action="" onSubmit={buscarcliente}>
                                <div className="row gy-4 d-flex justify-content-end align-items-end">
                                    <div className="col-12 col-md-6 col-xl-3">
                                        <InputComponent
                                            placeholder="Buscar"
                                            label="Buscar usuario"
                                            styleLabel="fw600 WorkSans"
                                            htmlFor="bloque"
                                            type="search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 col-xl-2">
                                        <button type="submit" className={`${stylebtn.btn} ${stylebtn.primary} `}>
                                            BUSCAR
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>

                    <section>
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered tableGeneral">
                                <thead>
                                    <tr>
                                        <th scope="col " className="color-madera">
                                            #
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Nombres
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Nombre de usuario
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Rol
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Editar
                                        </th>
                                        <th scope="col" className="color-madera">
                                            Eliminar
                                        </th>

                                    </tr>
                                </thead>
                                {currentPageDataUser && currentPageDataUser?.length !== 0 ? (
                                    <tbody>
                                        {currentPageDataUser?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th>{index + 1}</th>
                                                    <td>{item?.nombre}</td>
                                                    <td>{item?.username}</td>
                                                    <td>{item?.rol}</td>


                                                    <td>
                                                        <button
                                                            onClick={() => handleShowEditar(item)}
                                                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                                                        >
                                                            {' '}
                                                            <Icon icon="raphael:edit" />
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            onClick={() => {
                                                                handleShowEliminar(item);
                                                            }}
                                                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                                                        >
                                                            {' '}
                                                            <Icon icon="majesticons:delete-bin" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr>
                                            {' '}
                                            <td colSpan={12} className="text-center">
                                                SIN USUARIOS
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>

                    </section>

                    {pageCount > 1 && (
                        <PaginadorComponent
                            setCurrentPage={setCurrentPage}
                            pages={pageCount}
                            styleGroup="d-flex justify-content-center pt-4"
                        />
                    )}

                    <div className='d-flex justify-content-end'>
                        <Link
                            className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-dark`}
                            to={'/configuracion'}
                        >
                            {' '}
                            <Icon icon="icon-park-solid:back" />
                        </Link>
                    </div>
                </div>
            )}


            {/** modal eliminar un cliente**/}
            <section>
                <ModalGeneralComponent
                    styleGroup="d-flex align-items-center modal-general "
                    styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
                    show={showEliminar}
                    handleClose={handleCloseEliminar}
                >
                    <form action="">
                        <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar a ${currentUser?.nombre} ?`}</TitleH2Component>

                        <div className="d-flex justify-content-end">
                            <button type="button" onClick={handleCloseEliminar} className={`btn ${stylebtn.btn} ${stylebtn.danger} `}>
                                Cancelar
                            </button>
                            <button type="button" className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`} onClick={eliminarUser}>
                                Si
                            </button>
                        </div>
                    </form>
                </ModalGeneralComponent>
            </section>

            {/** modal editar Cliente**/}
            <section>
                <ModalGeneralComponent
                    ModalHeader
                    titulo={`${addUser ? 'REGISTRAR' : 'EDITAR'} USUARIOS`}
                    styleGroup="d-flex align-items-center modal-general "
                    styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
                    show={showEdit}
                    handleClose={handleClose}
                    handleShow={handleShowEditar}
                >
                    <div className="container">
                        <form action="" onSubmit={addUser ? addUsuario : editarUser}>

                            <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">{mensaje}</ParrafoComponent>


                            <div className="row g-4">

                                <div className="col-12">
                                    <InputComponent
                                        placeholder="Nombres"
                                        label="Nombre"
                                        styleLabel="fw600 WorkSans"
                                        htmlFor="bloque"
                                        type="text"
                                        value={formDataUser.nombre}
                                        name="nombre"
                                        onChange={handleInputChangeUser}
                                    />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <InputComponent
                                        label="Nombre usuario*"
                                        placeholder="nombre usuario*"
                                        styleLabel="fw600 WorkSans"
                                        htmlFor="bloque"
                                        type="text"
                                        value={formDataUser.username}
                                        name="username"
                                        onChange={handleInputChangeUser}
                                    />
                                </div>

                                {addUser && <div className="col-12 col-sm-6">
                                    <InputComponent
                                        label="Contraseña*"
                                        placeholder="Contraseña*"
                                        styleLabel="fw600 WorkSans"
                                        htmlFor="bloque"
                                        type="password"
                                        value={formDataUser.password}
                                        name="password"
                                        onChange={handleInputChangeUser}
                                    />
                                </div>}
                                <div className="col-12 col-sm-6 d-flex flex-column ">
                                    <label>
                                        <input
                                            type="radio"
                                            name="rol"
                                            value="admin"
                                            checked={formDataUser.rol === "admin"}
                                            onChange={(e) =>
                                                setFormDataUser({ ...formDataUser, rol: e.target.value })
                                            }
                                            className="me-2"
                                        />
                                        Admin
                                    </label>

                                    <label>
                                        <input
                                            className="me-2"
                                            type="radio"
                                            name="rol"
                                            value="vendedor"
                                            checked={formDataUser.rol === "vendedor"}
                                            onChange={(e) =>
                                                setFormDataUser({ ...formDataUser, rol: e.target.value })
                                            }
                                        />
                                        Vendedor
                                    </label>
                                </div>

                                {addUser &&
                                    formDataUser.rol === "admin" && isSuper &&

                                    <div className="col-12 col-sm-6 d-none">
                                        <InputComponent
                                            label="Pin"
                                            placeholder="Pin"
                                            styleLabel="fw600 WorkSans"
                                            htmlFor="bloque"
                                            type="password"
                                            value={formDataUser.pin}
                                            name="pin"
                                            onChange={handleInputChangeUser}
                                        />
                                    </div>}
                            </div>

                            <div className="d-flex justify-content-end mt-4">
                                <button type="button" onClick={handleClose} className={`btn ${stylebtn.btn} ${stylebtn.danger} `}>
                                    Cancelar
                                </button>
                                {
                                    <button type="submit" className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}>
                                        {addUser ? 'Guardar' : 'Editar'}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </ModalGeneralComponent>
            </section>
        </Fragment>
    )
}
export default ConfigurarUsersPege;